import { Png } from "common/assets";
import { useResolution } from "common/hooks";
import { EColors } from "common/styles";
import { Styled } from "components/Styled";
import { Fade } from "react-awesome-reveal";
import { ButtonsWrapper } from "./ButtonsWrapper";
import {
  ImageBarCode,
  StyledContainerWrapper,
  StyledImageWrapper,
  StyledSectionBonusesProgramme,
  StyledTitle,
} from "./styled";

export const BonusesProgramme = () => {
  const { isMinScreen1000 } = useResolution();
  return (
    <StyledSectionBonusesProgramme color={EColors.bg_dark}>
      <StyledContainerWrapper>
        <Styled.Half>
          <Fade direction="up" triggerOnce>
            <Styled.H2 color={EColors.white}>
              Накопичуйте паливо у нашому додатку
            </Styled.H2>
            <Styled.PBody1 color={EColors.white}>
              Завантажте наш безкоштовний мобільний додаток, щоб отримати доступ
              до ексклюзивних переваг. Кожен раз, коли ви заправляєте свій
              автомобіль на нашій автозаправній станції, ви отримуєте бонуси –
              паливні бали, які накопичуються в вашому обліковому записі.
            </Styled.PBody1>
            <ButtonsWrapper />
          </Fade>
        </Styled.Half>
        <StyledImageWrapper>
          <ImageBarCode
            src={isMinScreen1000 ? `${Png.Barcode}` : `${Png.BarcodeMob}`}
            alt="barcode"
          />
        </StyledImageWrapper>
      </StyledContainerWrapper>
    </StyledSectionBonusesProgramme>
  );
};
